import { useRef, useState } from 'react'
import { campaignPosterUrl, campaignVideoUrl } from './campaignVideoUrl'
import './campaign-video.css'

const label = 'Apresentação da Oficina IA com Arthur'

/**
 * Vídeo gravado com a câmera em círculo. O arquivo é quadrado e recortado na
 * bolinha; os controles nativos ficariam cortados pelo círculo, por isso a
 * reprodução é um botão próprio: um toque começa, outro pausa.
 */
export function CircleVideo({ src, className = '', label: fixedLabel }: { src: string; className?: string; label?: string }) {
  const video = useRef<HTMLVideoElement>(null)
  const [playing, setPlaying] = useState(false)
  const toggle = () => {
    const element = video.current
    if (!element) return
    if (element.paused) void element.play()
    else element.pause()
  }
  // Com um rótulo fixo (a landing usa a frase aprovada do protótipo), o estado fica só em aria-pressed.
  const buttonLabel = fixedLabel ?? (playing ? 'Pausar apresentação' : 'Assistir à apresentação')
  return <div className={`circle-video${playing ? ' circle-video--playing' : ''} ${className}`.trim()}>
    <img className="circle-video__poster" src={campaignPosterUrl} alt="" width="800" height="800" loading="lazy" decoding="async" />
    <video ref={video} preload="none" playsInline poster={campaignPosterUrl} aria-label={fixedLabel ?? label}
      onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} onClick={toggle}>
      <source src={src} type="video/mp4" />
      Seu navegador não consegue reproduzir este vídeo.
    </video>
    <button type="button" className="circle-video__button" onClick={toggle} aria-pressed={playing} aria-label={buttonLabel}>
      <svg viewBox="0 0 48 48" aria-hidden="true">{playing
        ? <path d="M15 12h6v24h-6zm12 0h6v24h-6z" fill="currentColor" />
        : <path d="m18 13 18 11-18 11z" fill="currentColor" />}</svg>
    </button>
  </div>
}

export default function CampaignVideo({ src = campaignVideoUrl() }: { src?: string | null }) {
  return <figure className="campaign-video">
    {src ? <CircleVideo src={src} /> : <div className="campaign-video__placeholder">
      <img src="/assets/illustrations/oficina-mundo-de-ideias.webp" alt="" width="1536" height="1024" loading="lazy" decoding="async" />
      <div className="campaign-video__message">
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><rect x="5" y="9" width="38" height="30" rx="7" stroke="currentColor" strokeWidth="2" /><path d="m20 17 12 7-12 7z" fill="currentColor" /></svg>
        <strong>Vídeo de apresentação</strong>
        <span>Em breve, uma explicação minha por aqui.</span>
      </div>
    </div>}
    <figcaption>Arthur Fischer · Oficina IA</figcaption>
  </figure>
}
